<template>
    <div class="national">
        <h2>广西疫情情况</h2>
        <div class="update-time" v-if="asTime" style="margin-bottom: 0.3rem;">{{asTime}}24时（北京时间）数据统计</div> 
        <div class="sink-state">
            <ul>
                <li v-for="(item,index) in diseaseList" :key="index">
                    <div :class="`num s${index + 1}`">{{item.description}}</div>
                    <div class="state">{{item.title}}</div>
                </li>
            </ul>
        </div>
        <div class="gx-map">
            <Maps></Maps>
        </div>   
        <div class="detail">
            <a href="https://v.gxnews.com.cn/zt/2020yq" target="_blank">点击了解详细数据</a>
        </div>
        <h2>全国疫情情况</h2>
        <div class="update-time" v-if="lastUpdateTime">截止本日{{lastUpdateTime}}的数据统计</div>   
        <div class="state-box">
            <ul>
                <li>
                    <div class="compare">较昨日+{{chinaAdd.confirm}}</div>
                    <div class="num s1">{{chinaTotal.confirm}}</div>
                    <div class="state">确诊</div>
                </li>
                <li>
                    <div class="compare">较昨日+{{chinaAdd.suspect}}</div>
                    <div class="num s2">{{chinaTotal.suspect}}</div>
                    <div class="state">疑似</div>
                </li>
                <li>
                    <div class="compare">较昨日+{{chinaAdd.heal}}</div>
                    <div class="num s3">{{chinaTotal.heal}}</div>
                    <div class="state">治愈</div>
                </li>
                <li>
                    <div class="compare">较昨日+{{chinaAdd.dead}}</div>
                    <div class="num s4">{{chinaTotal.dead}}</div>
                    <div class="state">死亡</div>
                </li>
            </ul>
        </div>         
    </div>
</template>

<script>
import $ from 'jquery';
import jsonp from 'jsonp'
import Maps from './maps.vue'

export default{
    name: 'national',
    data(){
        return{
            diseaseList: [],
            asTime: '',
            plagueList: [],
            chinaAdd: {},
            chinaTotal: {},
            lastUpdateTime: '' 
        }   
    },
    created(){
        this.axios.get('/yq/getData').then((res) => {
            let data = res.data.data;
            this.chinaAdd = data.chinaAdd;   
            this.chinaTotal = data.chinaTotal; 
            this.lastUpdateTime = data.lastUpdateTime.split(' ')[1];  
        })
        jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=50920&start=1&limit=20', null, (err, data) => {
            if (err) {
                console.error(err.message);
            } else {
                this.diseaseList = data;
            }
        })
        jsonp('https://v.gxnews.com.cn/index.php?c=json&a=getArticles&detail=1&sortids=50919&start=0&limit=20', null, (err, data) => {
            if (err) {
                console.error(err.message);
            } else {
                this.asTime = data[14].title;
            }
        })
    },
    mounted(){
        setTimeout(() => {
            $('.national').stop().animate({
                'padding': 0,
                'height': 0
            }, 2000)
        }, 10000)
    },
    components:{
        Maps
    }
}
</script>

<style lang="less" scoped>
    .national{
        padding: 0.4rem 0.3rem 0.35rem 0.3rem;
        text-align: center;
        overflow: hidden;
        h2{
            display: inline-block;
            border-radius: 0.5rem;
            background: #2960bc;
            padding: 0 1.7rem;
            color: #fff;
            font-weight: bold;
            font-size: 0.5rem;
            line-height: 1.8;
            margin-bottom: 0.3rem;
        }
        .update-time{
            font-size: 0.38rem;
            color: #c6423d;
        }
        .sink-state{
            overflow: hidden;
            li{
                width: 16.6%;
                float: left;
                .num{
                    font-size: 0.52rem;
                    font-weight: bold;
                }
                .s1{
                    color: #e7462b;
                }
                .s2{
                    color: #ec7d2c;
                }
                .s3{
                    color: #8b5348;
                }
                .s4{
                    color: #43a28f;
                }
                .s5{
                    color: #3f4f71;
                }
                .state{
                    padding: 0.03rem 0.2rem;
                    font-size: 0.32rem;
                    color: #3b3b3b;
                    background: #f0f5fd;
                    display: inline-block;
                    border-radius: 0.3rem;
                }
            }
        }
        .state-box{
            overflow: hidden;
            margin-top: 0.5rem;
            li{
                width: 25%;
                float: left;
                .compare{
                    font-size: 0.26rem;
                    color: #3f4f71;
                }
                .num{
                    font-size: 0.52rem;
                    font-weight: bold;
                }
                .s1{
                    color: #e7462b;
                }
                .s2{
                    color: #8b5348;
                }
                .s3{
                    color: #43a28f;
                }
                .s4{
                    color: #3f4f71;
                }
                .state{
                    padding: 0.03rem 0.2rem;
                    font-size: 0.32rem;
                    color: #3b3b3b;
                    background: #f0f5fd;
                    display: inline-block;
                    border-radius: 0.3rem;
                }
            }
        }
        .detail{
            padding-bottom: 0.4rem;
            margin-bottom: 0.4rem;
            border-bottom: 1px solid #eaeaea;
            a{
                font-size: 0.32rem;
                color: #333;
            }
        }
    }   
</style>   